import React, {PropTypes, Component} from "react";
import {inject, observer} from "mobx-react";
import {
    Button,
    DropdownItem,
    DropdownToggle,
    Dropdown,
    Input,
    ButtonDropdown,
    DropdownMenu,
    FormGroup,
    Label,
    Container,
    Row,
    Col
} from 'reactstrap';
import DataWrapper from "../../../principal/containers/DataWrapper";
import _ from 'lodash';
import {Redirect} from "react-router-dom";
import {FormWithActions} from "../../../comum/components/FormWithActions";
import LancamentoHorasStore from "../stores/LancamentoHorasStore";
import FontAwesome from "react-fontawesome";
import moment from "moment";
import NumberFormat from "react-number-format";
import {toJS} from "mobx";

@inject("store")
@observer
export class LancamentoHoras extends Component {

    constructor(props) {
        super(props);
        this.state = this.props.store.appStore;
        this.lancamentoStore = new LancamentoHorasStore(this.props.onChange);
        this.appStore = this.props.store.appStore;
    }

    componentDidMount() {
        this.lancamentoStore.listaLancamentoDias = toJS(this.props.listaLancamentoDias);
        this.lancamentoStore.prepararListaLancamentoDias(this.props.dataInicio, this.props.dataFim, this.props.tiposHora)
    }

    componentWillReceiveProps(nextProps) {
        this.lancamentoStore.listaLancamentoDias = nextProps.listaLancamentoDias.slice(0);
        this.lancamentoStore.prepararListaLancamentoDias(nextProps.dataInicio, nextProps.dataFim, nextProps.tiposHora)
    }

    static propTypes = {
        listaLancamentoDias: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.object,
        ]),
        tiposHora: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.object,
        ])
    };

    dadosFaltaTotalGdvEObservacoes(lancamentoDia) {
        const detalhes = [
            <td key={moment(lancamentoDia.data).format("DDMMYYYY") + "_1"}>
                {!this.props.readOnly ? (
                    <FormGroup check>
                        <Label check>
                            <Input type="checkbox" checked={lancamentoDia.falta} onChange={() => this.lancamentoStore.toggleFalta(lancamentoDia)}/>
                        </Label>
                    </FormGroup>
                ) : (
                    <span>{lancamentoDia.falta ? "Sim" : "Não"}</span>
                )}
            </td>,
            <td key={moment(lancamentoDia.data).format("DDMMYYYY") + "_2"}>{lancamentoDia.falta ? 0 : lancamentoDia.totalHoras}</td>
        ];

        if(this.props.controller.exibeCampoGdvNoLancamentoHoras) {
            detalhes.push(
            <td key={moment(lancamentoDia.data).format("DDMMYYYY") + "_3"}>
                {!this.props.readOnly ? (
                    <FormGroup check>
                        <Label check>
                            <Input type="checkbox" checked={!lancamentoDia.falta && lancamentoDia.gdv} onChange={() => this.lancamentoStore.toggleGdv(lancamentoDia)} disabled={lancamentoDia.falta}/>
                        </Label>
                    </FormGroup>
                ) : (
                    <span>{lancamentoDia.gdv ? "Sim" : "Não"}</span>
                )}
            </td>)
        }

        detalhes.push(
            <td key={moment(lancamentoDia.data).format("DDMMYYYY") + "_4"}>
                {lancamentoDia.observacoes.map((observacaoUsuario, index) => (
                    <p key={index}><strong>{observacaoUsuario.nomeUsuario}:</strong> {observacaoUsuario.observacao}</p>
                ))}
                {this.props.controller.nomeTarefa && <Input className="textarea-sm" type="textarea" value={lancamentoDia.observacaoUsuario} onChange={(event) => this.lancamentoStore.setObservacaoUsuario(lancamentoDia, event.target.value)}/>}
            </td>
        );


        return detalhes;
    }

    dadosFaltaTotalGdvEObservacoesMobile(lancamentoDia) {
        const detalhes = [
            <tr key={moment(lancamentoDia.data).format("DDMMYYYY") + "_1"}>
                <th className="lancamento-row" >Faltou</th>
                <td className="lancamento-row" colSpan={2}>{!this.props.readOnly ? (
                    <FormGroup check>
                        <Label check>
                            <Input type="checkbox" checked={lancamentoDia.falta} onChange={() => this.lancamentoStore.toggleFalta(lancamentoDia)}/>
                        </Label>
                    </FormGroup>
                ) : (
                    <span>{lancamentoDia.falta ? "Sim" : "Não"}</span>
                )}</td>
            </tr>,
            <tr key={moment(lancamentoDia.data).format("DDMMYYYY") + "_2"}>
                <th className="lancamento-row">Total</th>
                <td className="lancamento-row" colSpan={2}>
                    {lancamentoDia.falta ? 0 : lancamentoDia.totalHoras}
                </td>
            </tr>
        ];

        if(this.props.controller.exibeCampoGdvNoLancamentoHoras) {
            detalhes.push(
                <tr key={moment(lancamentoDia.data).format("DDMMYYYY") + "_3"}>
                    <th className="lancamento-row">GDV</th>
                    <td className="lancamento-row" colSpan={2}>{!this.props.readOnly ? (
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" checked={!lancamentoDia.falta && lancamentoDia.gdv} onChange={() => this.lancamentoStore.toggleGdv(lancamentoDia)} disabled={lancamentoDia.falta}/>
                            </Label>
                        </FormGroup>
                    ) : (
                        <span>{lancamentoDia.gdv ? "Sim" : "Não"}</span>
                    )}</td>
                </tr>)
        }

        detalhes.push(
            <tr key={moment(lancamentoDia.data).format("DDMMYYYY") + "_4"}>
                <td className="lancamento-row" colSpan={3}>
                    {lancamentoDia.observacoes.map((observacaoUsuario, index) => (
                        <p key={index}><strong>{observacaoUsuario.nomeUsuario}:</strong> {observacaoUsuario.observacao}</p>
                    ))}
                    {this.props.controller.nomeTarefa && <Input className="textarea-sm" type="textarea" placeholder="Obs..." value={lancamentoDia.observacaoUsuario} onChange={(event) => this.lancamentoStore.setObservacaoUsuario(lancamentoDia, event.target.value)}/>}
                </td>
            </tr>
        );


        return detalhes;
    }

    lancamentoDiaForm(lancamentoDia, lancamentoDiaIndex) {
        return (
        <tr key={moment(lancamentoDia.data).format("DD/MM/YYYY")} className={moment(lancamentoDia.data).weekday() === 6 || moment(lancamentoDia.data).weekday() === 0 ? "lancamento-horas-table weekend" : "lancamento-horas-table"}>
            {this.appStore.width > 768 ? (
                [
                    <th key="date1" width={140}>{moment(lancamentoDia.data).format('DD/MM/YYYY')}</th>,
                    <th key="date2" width={57}>{moment(lancamentoDia.data).format('ddd')}</th>
                ]
            ) : (
                <th key="date3">
                    {moment(lancamentoDia.data).format('DD/MM - ddd')}
                </th>
            )}
            <td className={this.props.readOnly ? "mobile-readonly-column" : ""}>
                {!lancamentoDia.falta &&
                    <table style={{width: '100%'}}>
                        <tbody>
                        {!this.props.readOnly &&
                        <tr>
                            <td width="40" style={{border: 'none'}}>
                                <ButtonDropdown isOpen={lancamentoDia.tiposHoraDropdown.open}
                                                toggle={() => lancamentoDia.tiposHoraDropdown.open = !lancamentoDia.tiposHoraDropdown.open}
                                                className="tipo-horas-dropdown">
                                    <DropdownToggle caret>
                                        <FontAwesome name="plus-circle"/>
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {this.props.tiposHora.map((tipo, index) => (
                                            <DropdownItem key={tipo.codigo}
                                                          onClick={() => this.lancamentoStore.adicionaLancamentotipo(lancamentoDia, tipo)}>{tipo.descricao}</DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </ButtonDropdown>
                            </td>
                        </tr>
                        }
                        {lancamentoDia.lancamentosHoras.map((lancamento, index) => (
                            <tr key={index}>
                                <td width="150" style={{verticalAlign: 'middle', border: 'none',  borderTop: "1px solid #eceeef"}} >{lancamento.tipo.descricao}</td>
                                {!this.props.readOnly ? (
                                    <td style={this.appStore.width <= 768 ? {minWidth: "76px", padding: "0.5rem 0", border: 'none',  borderTop: "1px solid #eceeef"} : {minWidth: "75px", maxWidth: "75px", border: 'none',  borderTop: "1px solid #eceeef"}}>
                                        <NumberFormat allowNegative={false}  value={lancamento.quantidade}
                                                      className="form-control" decimalSeparator={','}
                                                      decimalPrecision={2}
                                                      onChange={(event, values) => this.lancamentoStore.setQuantidadeHorasLancamento(lancamentoDia, index, values.floatValue)}/>
                                    </td>
                                ) : (
                                    <td style={{minWidth: "76px", maxWidth: "75px", border: 'none',  borderTop: "1px solid #eceeef"}}>{lancamento.quantidade}</td>
                                )}
                                {!this.props.readOnly &&
                                <td width="50" style={{border: 'none',  borderTop: "1px solid #eceeef"}}>
                                    <Button onClick={() => this.lancamentoStore.removeLancamentotipo(lancamentoDia, lancamento.tipo)} style={{margin: 0}}> <FontAwesome name="minus-circle"/></Button>
                                </td>
                                }
                            </tr>
                        ))}
                        {this.appStore.width <= 768 &&
                            this.dadosFaltaTotalGdvEObservacoesMobile(lancamentoDia)
                        }
                        </tbody>
                    </table>
                }

                {lancamentoDia.falta && this.appStore.width <= 768 &&
                <table style={{width: '100%'}}>
                    <tbody>
                        <tr key={moment(lancamentoDia.data).format("DDMMYYYY") + "_1"}>
                            <th style={{border: 'none', borderRight: "1px solid #eceeef"}}>Faltou</th>
                            <td style={{border: 'none'}}>{!this.props.readOnly ? (
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={lancamentoDia.falta} onChange={() => this.lancamentoStore.toggleFalta(lancamentoDia)}/>
                                    </Label>
                                </FormGroup>
                            ) : (
                                <span>{lancamentoDia.falta ? "Sim" : "Não"}</span>
                            )}</td>
                        </tr>
                    </tbody>
                </table>
                }

            </td>
            {this.appStore.width > 768 &&
                this.dadosFaltaTotalGdvEObservacoes(lancamentoDia)
            }

        </tr>)
    }


    render() {
        const lancamentos = [];
        for (let i = 0; i < this.lancamentoStore.listaLancamentoDias.length; i++) {
            lancamentos.push(this.lancamentoDiaForm(this.lancamentoStore.listaLancamentoDias[i], i));
        }

        return (
            <FormGroup> 
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th colSpan={this.appStore.width > 768 ? 2 : 1}>Data</th>
                        <th>Horas extras e horas noturnas</th>
                        {this.appStore.width > 768 && <th width={52}>Faltou</th>}
                        {this.appStore.width > 768 && <th>Total</th>}
                        {this.appStore.width > 768 && this.props.controller.exibeCampoGdvNoLancamentoHoras &&
                            <th width={52}>GDV</th>
                        }
                        {this.appStore.width > 768 && <th>Observações</th>}
                    </tr>
                    </thead>
                    <tbody>
                    {lancamentos}
                    </tbody>
                </table>
            </FormGroup>
        )
    }
}